export const formatString = (value: string, pattern: string) => {
  let i = 0;
  const v = value.toString();
  return pattern.replace(/#/g, _ => v[i++]);
};
